import { gql } from '@apollo/client';


export const CREATE_LINKMEPAY_COLLECT_ORDER_MUTATION = gql`
  mutation CreateCollectOrder($input: CreateCollectOrderInput!) {
    createLinkMePayCollectOrder(input: $input) {
      success
      code
      ch
      btc
      endTime
      amount
      orderNumber
      address
      ipnUrl
      token
      version
    }
  }
`;
export const CREATE_LINKMEPAY_PAYMENT_ORDER_MUTATION = gql`
  mutation CreatePaymentOrder($input: CreatePaymentOrderInput!) {
    createLinkMePayPaymentOrder(input: $input) {
      success
      code
      orderNumber
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query PaymentMethodActions($activeOnly: Boolean, $type: PaymentMethodActionType, $environmentId: Int) {
    paymentMethodActions(activeOnly: $activeOnly, type: $type, environmentId: $environmentId) {
     id
    name
    description
    code
    type
    isActive
    imageUrl
    label
    createdAt
    updatedAt
    environmentId
    chain
    coin
    }
  }
`;



export const PYBIT_ADDRESS_GET = gql`
  mutation PybitCashIn($paymentMethodActionId: Float!) {
    pybitAddressGet(
      input: {
        paymentMethodActionId: $paymentMethodActionId
      }
    ) {
      code
      msg
      data {
        address
        addrSign
        convertedAddr
      }
    }
  }
`;


export const PYBIT_WITHDRAW = gql`
  mutation PybitWithdraw($amount: String!,  $address: String!, $coin: String! , $code: String!, $chain: String!) {
    pybitWithdraw(input: {
      amount: $amount,
      code: $code
      address: $address
      coin: $coin
      chain: $chain
    }) {
      code
      msg
    }
  }
`;
